import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ExcludeShipmentServiceRequest } from 'app/generated/backend/shipment/api/exclude-shipment-service-request';
import { ExcludeShipmentServiceResponse } from 'app/generated/backend/shipment/api/exclude-shipment-service-response';

@Injectable()
export class ExcludeShipmentServiceHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	post(
		request: ExcludeShipmentServiceRequest
	): Observable<JsonResourceResponse<ExcludeShipmentServiceResponse>> {
		return this.http.post<JsonResourceResponse<ExcludeShipmentServiceResponse>>('api/v1/shipment/excludeShipmentService', request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		ExcludeShipmentServiceHandlerService
	]
})
export class ExcludeShipmentServiceHandlerModule { }
